window.addEventListener("resize", (event) => {
  if (window.innerWidth >= 1140) {
    document.querySelector(".Header__MainNav").style.position = "absolute";
    document.querySelector(".Header__MainNav").style.display = "flex";
    document.querySelector(".Header__MainNav").style.bottom = "0";
    document.querySelector(".Header__MainNav").style.left = "0";
    document.querySelector(".Header__MainNav").style.paddingBottom = "8px";
    document.querySelector(".Header__MainNav").style.paddingTop = "8px";
    document.querySelector(".Header__MainNav").style.textAlign = "center";
    document.querySelector(".Header__MainNav").style.width = "100%";
    document.querySelector(".Header__MainNav").style.justifyContent = "center";
    document.querySelector(".Header__MainNav").style.boxShadow =
      "0px 0px 2px 0px #222";
    document.querySelector(".Header__MainNav").style.marginRight = "45px";
    document.querySelector("#shopify-section-header").style.height = "112.5px";
  } else {
    document.querySelector("#shopify-section-header").style.height = "auto";
    document.querySelector(".Header__MainNav").style.display = "none";
  }
});
